export default "__VITE_ASSET__ChVeBOsv__"